// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18tJH","largestCol":"styles_largestCol__1cANY","smallestCol":"styles_smallestCol__2R2FN"};